import { render } from "./ServerNameEditModal.vue?vue&type=template&id=33b7f2f4&scoped=true"
import script from "./ServerNameEditModal.vue?vue&type=script&lang=js"
export * from "./ServerNameEditModal.vue?vue&type=script&lang=js"

import "./ServerNameEditModal.vue?vue&type=style&index=0&id=33b7f2f4&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b7f2f4"]])

export default __exports__